import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFileDialog } from 'shell/components';
import { CONTENT_BANK_RESOURCES_MB_LIMIT } from 'utils/constants';
import { bytesToMB } from 'utils/helper';

const ALLOWED_FILE_TYPES = [
    'application/pdf',
    // 'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
];

const UploadContentBankResourcesDialog = memo(({ open, resources, onClose, onClick }) => {
    const [error, setError] = useState('');
    const { t } = useTranslation('assignment');

    const handleClickUpload = (files) => {
        const sizeAlreadyUploaded = bytesToMB(
            [
                ...files.map(({ data }) => data.size),
                ...resources.filter(({ active }) => active).map(({ data }) => data.size),
            ].reduce((acc, cur) => acc + cur, 0)
        );
        if (sizeAlreadyUploaded > CONTENT_BANK_RESOURCES_MB_LIMIT) {
            setError(t('common:errors.upload-exceeds-limit', 'Uploads exceed the file upload limit.'));
            return;
        }
        onClick(
            files.map((file) => ({
                ...file,
                description: '',
                resource_type: '',
            }))
        );
        onClose();
    };

    return (
        <UploadFileDialog
            allowedFileTypes={ALLOWED_FILE_TYPES}
            description={t(
                'upload-files.description',
                'Please upload only essential materials for this assignment (max 200MB) to avoid errors. Please make sure each file is no larger than 30MB.'
            )}
            error={error}
            open={open}
            title={t('upload-files.title', 'Upload Files')}
            onClickUpload={handleClickUpload}
            onClose={onClose}
        />
    );
});

export default UploadContentBankResourcesDialog;
